'use client';

import { gotipathLibraryId } from '@/config';

type Props = {
  url: string;
};

export default function GotipathPlayer({ url }: Props) {
  return (
    <div
      style={{
        position: 'relative',
        paddingBottom: '56.25%',
        height: 0,
        overflow: 'hidden',
      }}
    >
      <iframe
        src={`https://player.gotipath.com/stream/${gotipathLibraryId}/default/${url}?autoplay=true&preload=true&loop=true&muted=true`}
        loading="lazy"
        style={{
          border: 'none',
          position: 'absolute',
          top: 0,
          height: '100%',
          width: '100%',
        }}
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowFullScreen
      ></iframe>
    </div>
  );
}
